import * as angular from 'angular';
import { DATES } from 'app/_constants/dates.constant';

class SecondaryTradeDetailsSectionComponentCtrl implements ng.IController {
    response: ResponseDto;
    proposal: ProposalDto;
    noTitle: boolean;

    constructor(private DATES: DATES) {}

    $onInit() {}
}

angular.module('app').component('pkpSecondaryTradeDetailsSection', {
    controller: SecondaryTradeDetailsSectionComponentCtrl,
    template:
        require('app/secondary-trading/secondary-trade-details-section.component.html'),
    bindings: {
        response: '<',
        proposal: '<',
        noTitle: '<?'
    }
});
